import React from 'react'
import { useReactions } from '../../hooks/useReactions'
import ReactionBar from './ReactionBar'
import FamilyReactionsGathered from './FamilyReactionsGathered'
import './Reactions.css'

/**
 * ReactionsSection — composite drop-in component.
 *
 * Drop this into any content detail page to add Legacy Reactions.
 *
 * Usage:
 *   <ReactionsSection contentType="story" contentId={id} />
 *   <ReactionsSection contentType="milestone" contentId={milestoneId} />
 */
function ReactionsSection({ contentType, contentId }) {
  const {
    reactions,
    myReactions,
    grouped,
    loading,
    togglingType,
    toggle,
    updateNote,
  } = useReactions(contentType, contentId)

  if (loading) {
    return (
      <div className="reactions-section reactions-loading">
        <div className="reactions-loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    )
  }

  return (
    <div className="reactions-section">
      {/* Divider */}
      <div className="reactions-divider" />

      {/* User's reaction buttons */}
      <ReactionBar
        contentType={contentType}
        myReactions={myReactions}
        togglingType={togglingType}
        onToggle={toggle}
        onUpdateNote={updateNote}
        reactions={reactions}
      />

      {/* Family gathered display */}
      <FamilyReactionsGathered grouped={grouped} />
    </div>
  )
}

export default ReactionsSection
